import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DpadZoneType } from '@core/constants';
import { FullscreenService } from '@core/services/common';
import { DpadControlService } from '@core/services/common/dpad-control.service';
import { TimeService } from '@core/services/common/time.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'caremoni-us-menu-right-cs-column',
    templateUrl: './us-menu-right-cs-column.component.html',
    styleUrl: './us-menu-right-cs-column.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class UsMenuRightCsColumnComponent implements OnInit {

    @Input() currentHeaders: any[] = [];
    @Input() midMenuId: number = 0;
    @Output() onChangeHeaderColumnsHandle = new EventEmitter();
    @Output() onChangeFlashingTypeHandle = new EventEmitter();

    isNyuSho: boolean = true;
    private readonly maxNumCols = 3;
    DpadZoneType = DpadZoneType;
    get numCols(): number {
      if (this.currentHeaders.length === 0) return 1;
      const divisor = this.currentHeaders.length === 4 ? 2 : 4;
      return Math.min(this.maxNumCols, Math.ceil(this.currentHeaders.length / divisor));
    }
    get gridColumns(): string {
      return `repeat(${this.numCols}, 1fr)`;
    }
    
    get gridRows(): string {
      return `repeat(${Math.ceil(this.currentHeaders.length / this.numCols)}, 20px)`;
    }
    subscription: Subscription  = new Subscription();

    constructor(
        private dpadControlService: DpadControlService,
        private _timeService: TimeService,
        private fullScreenService: FullscreenService,
    ){}

    async ngOnInit():Promise<void>{
      this.currentHeaders = this.currentHeaders.filter(x => x?.field !== "index" && x?.field !== "priority");
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    getXTabDpad(i: number): number {
      return i % this.numCols;
    }

    getYTabDpad(i: number): number {
      return Math.floor(i / this.numCols);
    }
    onChangeHeaderColumns(data: any) {
      this.onChangeHeaderColumnsHandle.emit(data);
    }
    
    onChangeFlashingType() {
      this.onChangeHeaderColumnsHandle.emit();
    }

}
